// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"18596b42","703":"a07cb373","787":"8466e274"}[chunkId] + ".chunk.js";
};